import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Building2, BookOpen, Globe, MapPin, Tags, Sparkles, CreditCard, Users, FileText, BarChart3, LogOut, GraduationCap, Menu } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/institutions", label: "Institutions", icon: Building2 },
  { to: "/admin/courses", label: "Courses", icon: BookOpen },
  { to: "/admin/countries", label: "Countries", icon: Globe },
  { to: "/admin/cities", label: "Cities", icon: MapPin },
  { to: "/admin/categories", label: "Categories", icon: Tags },
  { to: "/admin/specialisations", label: "Specialisations", icon: Sparkles },
  { to: "/admin/plans", label: "Plans", icon: CreditCard },
  { to: "/admin/payments", label: "Payments", icon: CreditCard },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/pages", label: "Pages / CMS", icon: FileText },
  { to: "/admin/reports", label: "Reports", icon: BarChart3 },
];

function Nav({ onNavigate }) {
  return (
    <nav className="space-y-1">
      {LINKS.map((l) => (
        <NavLink key={l.to} to={l.to} end={l.end} onClick={onNavigate} data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+|\/|\s/g, "-")}`}
          className={({ isActive }) => `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition ${
            isActive ? "bg-blue-800 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white"}`}>
          <l.icon className="h-4 w-4" /> {l.label}
        </NavLink>
      ))}
    </nav>
  );
}

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50">
      <aside className="fixed inset-y-0 left-0 hidden w-64 flex-col bg-slate-900 p-4 lg:flex">
        <Link to="/admin" className="mb-6 flex items-center gap-2 px-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-red-600 text-white"><GraduationCap className="h-4 w-4" /></span>
          <span className="font-heading text-sm font-bold text-white">Admin Panel</span>
        </Link>
        <div className="flex-1 overflow-y-auto"><Nav /></div>
        <div className="border-t border-slate-800 pt-3">
          <Button variant="ghost" size="sm" className="w-full justify-start text-slate-300 hover:bg-slate-800 hover:text-white" onClick={() => navigate("/")}>View Site</Button>
          <Button variant="ghost" size="sm" className="w-full justify-start text-slate-300 hover:bg-slate-800 hover:text-white" onClick={() => { logout(); navigate("/"); }} data-testid="admin-logout">
            <LogOut className="mr-2 h-4 w-4" /> Sign out
          </Button>
        </div>
      </aside>

      <div className="lg:pl-64">
        <header className="flex items-center gap-3 border-b border-slate-200 bg-white px-4 py-3 lg:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild><Button variant="ghost" size="icon" data-testid="admin-mobile-menu"><Menu className="h-6 w-6" /></Button></SheetTrigger>
            <SheetContent side="left" className="w-64 bg-slate-900 p-4">
              <div className="mb-6 mt-2 font-heading font-bold text-white">Admin Panel</div>
              <Nav onNavigate={() => setOpen(false)} />
            </SheetContent>
          </Sheet>
          <span className="font-heading font-bold text-slate-900">Admin Panel</span>
        </header>
        <main className="p-4 md:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
